/**
 * Status de um participante dentro do fluxo de integração — o que aparece na coluna Status da
 * lista de adesões. As cores do badge acompanham as da lista de adesões da campanha: aguardando
 * em amarelo, sucesso em verde e erro em vermelho (ver `STATUS_MODIFIER` em
 * status-badge.component.ts).
 */
export enum IntegracaoParticipanteStatus {
  Aguardando = 'Aguardando',
  Sucesso = 'Sucesso',
  Erro = 'Erro',
}
